import { cn } from './cn.js';
import { Icon } from './Icon.js';

/**
 * Quem cuida de um registro: o ícone de pessoa numa pastilha e o nome ao lado
 * — o responsável do card no quadro, na tabela e na mesa (07/10/2026).
 *
 * **Ícone, e não iniciais.** O `Avatar` é a pastilha de iniciais da casa; aqui
 * o desenho pediu o ícone de usuário, que é o lugar onde uma foto entraria se
 * um dia o produto tiver foto de perfil (hoje não tem — ver `Avatar`).
 *
 * **"Sem responsável" é um fato, e aparece.** Com `name` nulo a pastilha fica
 * tracejada e o texto diz `emptyLabel`, apagado. Um espaço em branco no card
 * faria a ausência parecer defeito de carregamento.
 *
 * O nome vem escrito ao lado, e por isso o ícone é `aria-hidden`.
 */
export function PersonMark({
  name,
  emptyLabel = 'Sem responsável',
  className,
}: {
  /** O nome de quem cuida; `null` é ninguém. */
  name: string | null;
  /** O texto quando ninguém cuida — "Sem analista". */
  emptyLabel?: string;
  className?: string;
}) {
  const empty = name === null || name.trim() === '';
  return (
    <span
      className={cn('flex min-w-0 items-center gap-1.5 text-xs', className)}
      title={empty ? emptyLabel : name}
    >
      <span
        aria-hidden
        className={cn(
          /* A mesma caixa da pastilha `sm` do `Avatar`, com as cores dela. */
          'grid size-5.5 shrink-0 place-items-center rounded-pequeno',
          empty
            ? 'border border-dashed border-borda-forte text-texto-tenue'
            : 'bg-chrome-alto text-chrome-texto',
        )}
      >
        <Icon nome="pessoa" size={16} className="size-3.5" />
      </span>
      <span className={cn('truncate', empty ? 'text-texto-tenue' : 'text-texto')}>
        {empty ? emptyLabel : name}
      </span>
    </span>
  );
}
